import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import { selectSeriesInfoForCurrentBib } from 'app/selectors/bibs/SeriesInfoSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import SeriesInfoActions from 'app/actions/SeriesInfoActions';
import SameSeriesOverlay from './SameSeriesOverlay';

export class SameSeriesOverlayContainer extends React.PureComponent {
  render() {
    return <SameSeriesOverlay {...this.props} />;
  }
}

SameSeriesOverlayContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  series: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape,
  seriesInfoActions: PropTypes.objectOf(PropTypes.func)
};

const mapStateToProps = state => ({
  isFetching: state.getIn(['bibs', 'seriesInfo', 'isFetching'], false),
  series: selectSeriesInfoForCurrentBib(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  seriesInfoActions: bindActionCreators(SeriesInfoActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SameSeriesOverlayContainer);
